import React from 'react';
import { Solution } from '../models';

interface SolutionResultsProps {
  solutions: Solution[];
}

const SolutionResults: React.FC<SolutionResultsProps> = ({
  solutions
}) => {
  if (solutions.length === 0) {
    return <div className="no-results">検索結果がありません</div>;
  }

  return (
    <div className="results-container">
      <h2>ソリューション検索結果 ({solutions.length}件)</h2>
      <div className="results-list">
        {solutions.map((solution, index) => (
          <div key={`${solution.competitionSlug}-${solution.rank}-${index}`} className="result-card">
            <div className="solution-header">
              <h3>#{solution.rank} - スコア: {solution.score.toFixed(4)}</h3>
              <p className="competition-slug">コンペティション: {solution.competitionSlug}</p>
            </div>
            <p className="summary">{solution.summary}</p>
            <div className="meta-info">
              <p><strong>ユーザー:</strong> {solution.userIds.join(', ')}</p>
              {solution.notebookUrl && (
                <p>
                  <strong>ノートブック:</strong> 
                  <a href={solution.notebookUrl} target="_blank" rel="noopener noreferrer">
                    {solution.notebookUrl}
                  </a>
                </p>
              )}
              {solution.repositoryUrl && (
                <p>
                  <strong>リポジトリ:</strong> 
                  <a href={solution.repositoryUrl} target="_blank" rel="noopener noreferrer">
                    {solution.repositoryUrl}
                  </a>
                </p>
              )}
            </div>
            {solution.techniquesUsed && solution.techniquesUsed.length > 0 && (
              <div className="techniques">
                <strong>使用技術:</strong>
                <div className="tags">
                  {solution.techniquesUsed.map((technique) => (
                    <span key={technique} className="tag">{technique}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SolutionResults;
